import { pathExistsSync } from "path-exists";
/**
 * Check if the current platform is Alpine
 */
export function isAlpine() {
    if (process.platform !== "linux") {
        return false;
    }
    try {
        return pathExistsSync("/etc/alpine-release");
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtYWxwaW5lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2lzLWFscGluZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBRTVDOztHQUVHO0FBQ0gsTUFBTSxVQUFVLFFBQVE7SUFDdEIsSUFBSSxPQUFPLENBQUMsUUFBUSxLQUFLLE9BQU8sRUFBRSxDQUFDO1FBQ2pDLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztJQUNELElBQUksQ0FBQztRQUNILE9BQU8sY0FBYyxDQUFDLHFCQUFxQixDQUFDLENBQUE7SUFDOUMsQ0FBQztJQUFDLE1BQU0sQ0FBQztRQUNQLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztBQUNILENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBwYXRoRXhpc3RzU3luYyB9IGZyb20gXCJwYXRoLWV4aXN0c1wiXG5cbi8qKlxuICogQ2hlY2sgaWYgdGhlIGN1cnJlbnQgcGxhdGZvcm0gaXMgQWxwaW5lXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBpc0FscGluZSgpIHtcbiAgaWYgKHByb2Nlc3MucGxhdGZvcm0gIT09IFwibGludXhcIikge1xuICAgIHJldHVybiBmYWxzZVxuICB9XG4gIHRyeSB7XG4gICAgcmV0dXJuIHBhdGhFeGlzdHNTeW5jKFwiL2V0Yy9hbHBpbmUtcmVsZWFzZVwiKVxuICB9IGNhdGNoIHtcbiAgICByZXR1cm4gZmFsc2VcbiAgfVxufVxuIl19